<ng-container
  *ngIf="
    templateOptions.direction === 'horizontal';
    then horizontal;
    else default
  "
>
</ng-container>

<ng-template #display>
  <app-bs-display [key]="key" [valueText]="value ? value : displayDefaultValue">
  </app-bs-display>
</ng-template>

<ng-template #inputTextarea>
  <textarea
    [id]="identifier"
    [name]="name"
    class="form-control"
    [ngClass]="
      hasRequiredError() ||
      hasPatternError ||
      hasMinLengthError ||
      hasMaxLengthError
        ? 'is-invalid'
        : touched
        ? 'is-valid'
        : ''
    "
    type="text"
    [(ngModel)]="value"
    [placeholder]="placeholder"
    #control="ngModel"
    [required]="required == 'true' || required == '' ? '' : undefined"
    [rows]="rows"
    [cols]="cols"
    [readonly]="readonly"
    (blur)="onTouched()"
    [disabled]="disabled"
    [maxlength]="_maxLength"
    [attr.aria-required]="isRequired"
    [attr.aria-describedby]="isShowErrors ? identifier + '-feedbacks' : null"
  ></textarea>
</ng-template>

<ng-template #default>
  <div
    class="form-group"
    [ngClass]="{
      'has-error has-danger':
        ngControl.touched && !ngControl.valid && !ngControl.disabled,
      'has-success': ngControl.touched && ngControl.valid
    }"
  >
    <label
      *ngIf="!isDisplay"
      class="form-control-label"
      [for]="identifier"
      [ngClass]="{ 'form-control-label-required': hasRequiredValidator() }"
      [attr.title]="labelTitle ? labelTitle : null"
      >{{ labelText }}</label
    >

    <ng-container
      *ngTemplateOutlet="isDisplay ? display : inputTextarea"
    ></ng-container>

    <small
      [id]="identifier + 'Help'"
      *ngIf="helpText"
      class="form-text text-muted"
    >
      {{ helpText }}</small
    >

    <ng-container *ngTemplateOutlet="feedback"> </ng-container>
  </div>
</ng-template>

<ng-template #horizontal>
  <div class="form-group row">
    <label
      *ngIf="!isDisplay"
      class="col-sm-3 form-control-label"
      [for]="identifier"
      [ngClass]="{ 'form-control-label-required': hasRequiredValidator() }"
      [attr.title]="labelTitle ? labelTitle : null"
      >{{ labelText }}</label
    >

    <div class="col-sm-9">
      <ng-container
        *ngTemplateOutlet="isDisplay ? display : inputTextarea"
      ></ng-container>

      <small
        [id]="identifier + 'Help'"
        *ngIf="helpText"
        class="form-text text-muted"
      >
        {{ helpText }}</small
      >

      <ng-container *ngTemplateOutlet="feedback"> </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #feedback>
  <ng-container *ngIf="isShowErrors">
    <div [id]="identifier + '-feedbacks'" class="invalid-feedback" role="alert">
      <div
        *ngFor="let error of errors; trackBy: trackByMessageKey"
        [innerText]="
          key + '.' + error.messageKey | translate : error.messageArgs
        "
      ></div>
    </div>
  </ng-container>
</ng-template>
